import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Menu } from "antd";
import "../../assets/css/blooddonation.scss";
import BreadCrum from "../../atoms/breadcrum/BreadCrum";
import CustomDropDown from "../../atoms/CustomDropDown/Index";
import FilterForm from "../../components/common/FilterForm";
import { filterIcon, FilterIcon } from "../../assets/icons";

const ListHeader = ({
  handleSearchChange,
  mainHeading,
  placeholder,
  btnText,
  linkBreadCrum,
  linkBreadCrum1,
  linkBreadCrum2,
  blinkBreadCrumText,
  linkbtn,
  csvData,
  disabled,
  exportFileName,
  blinkBreadCrumText1,
  blinkBreadCrumText2,
  blinkBreadCrumText3,
  filterOption,
  handleChangeSelect,
  filterOptionData,
  btnShow,
  searchShow,
  showLikeFilter,
  onShowLikeFilterClick,
  DropDown,
  searchValue,
  handleProjectSearchChange,
  showWorkerFilter,
  showFilter=true,
  showProjectFilter,
  moduleType='default',
  hideBreadcrumb=false,
  initialProjectId,
  linkBreadCrumState,
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    dateRange: null,
    project: initialProjectId || '',
    worker: '',
    vendor: '',
    userType: '',
    user: '',
    status: '',
    plan: ''
  });

  const getActiveFilterCount = () => {
    let count = 0;
    if (appliedFilters.dateRange) count++;
    if (appliedFilters.project) count++;
    if (appliedFilters.worker) count++;
    if (appliedFilters.vendor) count++;
    if (appliedFilters.userType) count++;
    if (appliedFilters.user) count++;
    if (appliedFilters.status && appliedFilters.status !== 'all') count++;
    if (appliedFilters.plan && appliedFilters.plan !== 'all') count++;
    return count;
  };

  const getMenu = () => (
    <Menu
      onClick={() => {
        setDropdownVisible(false);
      }}
    >
      <FilterForm
        handleSearchChange={(values) => {
        handleSearchChange(values);
          setAppliedFilters({
            dateRange: values.dateRange,
            project: values.project_id,
            worker: values.worker_id,
            vendor: values.vendor_id,
          userType: values.user_type,
          user: values.user_id,
          status: values.status,
          plan: values.plan
          });
        }}
        setDropdownVisible={setDropdownVisible}
        showWorkerFilter={showWorkerFilter}
        showProjectFilter={showProjectFilter}
        moduleType={moduleType}
        initialProjectId={initialProjectId}
      />
    </Menu>
  );

  return (
    <div className="w-full flex items-center justify-between">
      <div className="flex flex-col gap-4 w-full pt-5">
        {mainHeading && (
          <div className="font-semibold text-[20px] text-[#1E3A8A]">
            {mainHeading}
          </div>
        )}
        {!hideBreadcrumb && (
          <div className="w-full -mt-2">
            <BreadCrum
              firstLink={linkBreadCrum}
              firstLinkState={linkBreadCrumState}
              firstText={blinkBreadCrumText}
              secondLink={linkBreadCrum1}
              secondText={blinkBreadCrumText1}
              thirdText={blinkBreadCrumText2}
              fourthText={blinkBreadCrumText3}
              thirdLink={linkBreadCrum2}
            />
          </div>
        )}
      </div>
      <div className="col-lg-7 d-flex justify-content-end align-items-center list-header pr-0">
        {searchShow && (
          <div className="flex items-center">
            <div className="search-input-field !h-[45px] d-flex align-items-center mr-2">
              <i
                className="fas fa-search pl-2"
                style={{ color: "#6D7482", fontSize: "14.5px" }}
              ></i>
              <input
                type="text"
                placeholder={placeholder}
                className="pl-2"
                value={searchValue}
                onChange={(e) => handleProjectSearchChange?.(e.target.value)}
                // onChange={handleInputChange}
              />
            </div>
            {showFilter&&<div className="rounded w-[44px] h-[44px] bg-white flex items-center justify-center">
              <Dropdown
                overlay={getMenu()}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
                getPopupContainer={() => document.body}
              >
                <span className="cursor-pointer mt-[7px] relative">
                  {filterIcon}
                  {getActiveFilterCount() > 0 && (
                    <span className="absolute top-[13px] left-[52px] bg-[#F97316] text-white rounded-full w-4 h-4 flex items-center justify-center text-[10px]">
                      {getActiveFilterCount()}
                    </span>
                  )}
                </span>
              </Dropdown>
            </div>}
          </div>
        )}
        {showLikeFilter && (
          <div
            className="ml-auto cursor-pointer"
            onClick={onShowLikeFilterClick}
          >
            {FilterIcon}
          </div>
        )}
        {DropDown && (
          <div style={{ width: "200px" }}>
            <CustomDropDown
              value={filterOption}
              selectLabel="Select"
              handleChangeSelect={handleChangeSelect}
              option={filterOptionData}
            />
          </div>
        )}
        {btnText ? (
          btnShow ? (
            <Link to={linkbtn}>
              <button className="list-header-btn2 ml-2  d-flex align-items-center mr-2">
                <i className="fa-solid fa-circle-plus pr-2 pt-0"></i>
                {btnText}
              </button>
            </Link>
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default ListHeader;
